import { useLocation, useMatch } from '@reach/router';
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import { DateRange } from 'common/DateRange';
import permissions from 'common/permissions';
import Tabs from 'components/shared/Tabs';
import { useFeatures, usePermissions } from 'hooks';

import CorporateReport from './CorporateReport';
import DealerStepReport from './DealerStepReport';
import DealerStepReportV3 from './DealerStepReportV3';
import ReportsDateFilter, { getDefaultDateRange } from './ReportsDateFilter';
import VelocityEngageCorporateReport from './VelocityEngageCorporateReport';
import VelocityEngageModuleReport from './VelocityEngageModuleReport';

import './Reports.scss';

interface ReportsProps {
  path?: string;
}

enum ReportPaths {
  dealer = 'dealer-step',
  dealerV3 = 'dealer-step-v3',
  corporate = 'corporate',
  velocityEngageCorporate = 'velocityEngageCorporate',
  velocityEngageModule = 'velocityEngageModule',
}

const Reports: React.FC<ReportsProps> = (props) => {
  const { hasPermission } = usePermissions();
  const { hasFeature } = useFeatures();
  const location = useLocation();

  const [dateRange, setDateRange] = useState<DateRange>(getDefaultDateRange());
  console.log(dateRange);

  const defaultTabPath = () => {
    if (hasPermission(permissions.REPORTS_STEP_REPORT_VIEW)) {
      return ReportPaths.dealer;
    }
    if (hasPermission(permissions.REPORTS_CORPORATE_REPORT_VIEW)) {
      return ReportPaths.corporate;
    }
    if (
      hasPermission(permissions.PLUGIN_VELOCITYENGAGE_CORPORATE_REPORT_VIEW)
    ) {
      return ReportPaths.velocityEngageCorporate;
    }

    return ReportPaths.dealer;
  };

  const matchesVelocityEngageModuleReport = useMatch(
    ReportPaths.velocityEngageModule
  );

  return (
    <div className="Reports page vertical-scroll">
      <div className="Reports-panel-container">
        <Container fluid>
          <Row noGutters className="no-margin">
            <Col className="Reports-overview">
              {!matchesVelocityEngageModuleReport && (
                <ReportsDateFilter
                  allowCustomRange={location.pathname
                    .split('/')
                    .includes(ReportPaths.dealer)}
                  onChange={setDateRange}
                />
              )}
              <Tabs
                basePath="reports"
                defaultPath={defaultTabPath()}
                tabContentClassName={
                  (matchesVelocityEngageModuleReport ? '' : 'bg-white') +
                  ' tab-container'
                }
                className="full-width"
              >
                {hasPermission(permissions.REPORTS_STEP_REPORT_VIEW) && (
                  <DealerStepReport
                    path={ReportPaths.dealer}
                    title="Recon Step"
                    dateRange={dateRange}
                  />
                )}
                {hasFeature('STEP_REPORT_VERSION_3') &&
                  hasPermission(permissions.REPORTS_STEP_REPORT_VIEW) && (
                    <DealerStepReportV3
                      path={ReportPaths.dealerV3}
                      title="Recon Step V3"
                    />
                  )}
                {hasPermission(permissions.REPORTS_CORPORATE_REPORT_VIEW) && (
                  <CorporateReport
                    path={ReportPaths.corporate}
                    title="Recon Step Corporate"
                    dateRange={dateRange}
                  />
                )}
                {hasPermission(
                  permissions.PLUGIN_VELOCITYENGAGE_CORPORATE_REPORT_VIEW
                ) && (
                  <VelocityEngageCorporateReport
                    path={ReportPaths.velocityEngageCorporate}
                    title="Engage Corporate"
                    dateRange={dateRange}
                  />
                )}
                {hasPermission(permissions.PLUGIN_VELOCITYENGAGE_VIEW) && (
                  <VelocityEngageModuleReport
                    path={ReportPaths.velocityEngageModule}
                    title="Velocity Engage Module"
                  />
                )}
              </Tabs>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Reports;
